import script from "./ProjectVideosPageNavMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectVideosPageNavMenu.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectVideosPageNavMenu.vue?vue&type=style&index=0&id=e1d4d5b2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1d4d5b2"]])

export default __exports__